import { render, staticRenderFns } from "./ModalPost.vue?vue&type=template&id=33e42c97"
import script from "./ModalPost.vue?vue&type=script&lang=js"
export * from "./ModalPost.vue?vue&type=script&lang=js"
import style0 from "./ModalPost.vue?vue&type=style&index=0&id=33e42c97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports